
import React from "react";
import ShopifySettings from "@/components/dashboard/ShopifySettings";

const SettingsTab = ({ shopifyConfigured }: { shopifyConfigured: boolean }) => {
  return (
    <div className="space-y-6">
      <ShopifySettings />
    </div>
  );
};

export default SettingsTab;
